import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API_BASE from "../config/api";

function Listings() {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const selectedProvince = queryParams.get("location") || "";
    const selectedCategory = queryParams.get("category") || "";

    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);

    const [showCallPopup, setShowCallPopup] = useState(false);
    const [showMsgPopup, setShowMsgPopup] = useState(false);

    const [selectedBiz, setSelectedBiz] = useState(null);
    const [userMsg, setUserMsg] = useState("");

    const goToProfile = (id) => {
        navigate(`/business/${id}`);
    };

    const goToProfile1 = (id) => {
        navigate(`/business-website/${id}`);
    };

    // 🔥 Fetch data from backend when page loads
    useEffect(() => {
        setLoading(true); // show loader instantly

        fetch(
            `${API_BASE}/api/searchListings.php?location=${selectedProvince}&category=${selectedCategory}&search=${queryParams.get("search") || ""}`
        )
            .then((res) => res.json())
            .then((data) => {
                setListings(data.data || []);
                setLoading(false); // stop loader
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }, [selectedProvince, selectedCategory]);

    {/* SHOW LOADER FIRST */ }
    {
        loading && (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" role="status"></div>
                <p className="text-muted mt-2">Loading results...</p>
            </div>
        )
    }




    return (
        <div className="container my-4">

            {/* INTERNAL CSS */}
            <style>{`
                .filter-box {
                    background: #ffffff;
                    padding: 18px;
                    border-radius: 14px;
                    box-shadow: 0 4px 14px rgba(0,0,0,0.10);
                    position: sticky;
                    top: 100px;
                }

                .biz-card {
                    background: #fff;
                    border-radius: 14px;
                    padding: 18px;
                    margin-bottom: 22px;
                    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
                    border: none;
                    transition: 0.25s ease-in-out;
                }

                .biz-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 6px 20px rgba(0,0,0,0.18);
                }

                .biz-img {
                    height: 170px;
                    width: 100%;
                    object-fit: cover;
                    border-radius: 12px;
                }
                    .filter-box-advanced {
    background: #ffffff;
    padding: 22px;
    border-radius: 18px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
    position: sticky;
    top: 100px;
    transition: 0.3s ease-in-out;
}

.filter-box-advanced:hover {
    box-shadow: 0 12px 26px rgba(0,0,0,0.12);
}

/* Tags */
.filter-tag {
    background: #f1f3f5;
    padding: 4px 10px;
    border-radius: 50px;
    font-size: 12px;
    cursor: pointer;
    transition: 0.2s;
}

.filter-tag:hover {
    background: #0d6efd;
    color: white;
}

/* Selects */
.modern-select {
    border: none !important;
    background: #f8f9fa !important;
    padding: 8px !important;
    border-radius: 10px;
    font-size: 14px;
}

/* Rating Badges */
.rating-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.rating-badge {
    background: #f8f9fa;
    padding: 6px 12px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.2s;
    font-size: 14px;
}

.rating-badge:hover {
    background: #ffe08a;
}

/* Buttons */
.reset-btn {
    border-radius: 50px;
    padding: 5px 18px;
    border: 1px solid #ddd;
}

.apply-btn {
    border-radius: 50px;
    padding: 5px 18px;
    font-weight: 600;
}
    .modern-select {
    border-radius: 10px;
    background-color: #f8f9fa !important;
    border: 1px solid #e1e4e8;
    padding: 6px 10px;
    font-size: 13px;
    color: #495057;
    transition: 0.2s ease;
}

.modern-select:hover {
    background-color: #ffffff !important;
    border-color: #c4c9cf;
}

.modern-select:focus {
    border-color: #0d6efd !important;
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);
}.filter-box-advanced {
    background: #ffffff;
    padding: 22px;
    border-radius: 18px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
    position: sticky;
    top: 100px;

    /* 🔥 Make Scrollable */
    max-height: 82vh;
    overflow-y: auto;
    padding-right: 8px;
}

/* Slim Modern Scrollbar */
.filter-box-advanced::-webkit-scrollbar {
    width: 6px;
}

.filter-box-advanced::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 10px;
}

.filter-box-advanced::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}



            `}</style>

            <div className="row">

                <div className="col-md-3 mb-4">
                    <div className="filter-box-advanced">

                        <h5 className="fw-bold mb-3">Filters</h5>

                        {/* SEARCH */}
                        <div className="mb-3">
                            <label className="fw-semibold small">Search</label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text border-0 bg-light">
                                    <i className="bi bi-search"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control border-0 bg-light"
                                    placeholder="Search business..."
                                />
                            </div>
                        </div>

                        {/* POPULAR TAGS */}
                        <div className="mb-3">
                            <label className="fw-semibold small">Popular Tags</label>
                            <div className="d-flex flex-wrap gap-2 mt-2">
                                {["Hotel", "Salon", "Doctors", "Shop", "Education"].map((tag, i) => (
                                    <span key={i} className="filter-tag">#{tag}</span>
                                ))}
                            </div>
                        </div>

                        {/* PROVINCE */}
                        <div className="mb-3">
                            <label className="fw-semibold small">Province</label>
                            <select className="form-select form-select-sm modern-select">
                                <option value="">All Provinces</option>
                                <option>Koshi</option>
                                <option>Madhesh</option>
                                <option>Bagmati</option>
                                <option>Gandaki</option>
                                <option>Lumbini</option>
                                <option>Karnali</option>
                                <option>Sudurpashchim</option>
                            </select>
                        </div>

                        {/* CATEGORY */}
                        <div className="mb-3">
                            <label className="fw-semibold small">Category</label>
                            <select className="form-select form-select-sm modern-select">
                                <option value="">All Categories</option>
                                <option>Hotels</option>
                                <option>Restaurants</option>
                                <option>Shops</option>
                                <option>Services</option>
                                <option>Education</option>
                                <option>Technology</option>
                            </select>
                        </div>

                        {/* ⭐ ONE-ROW RATING DROPDOWN */}
                        <div className="mb-4">
                            <label className="fw-semibold small">Rating</label>

                            <select className="form-select form-select-sm modern-select">
                                <option value="">Any Rating</option>
                                <option value="5">★★★★★ & Up</option>
                                <option value="4">★★★★ & Up</option>
                                <option value="3">★★★ & Up</option>
                                <option value="2">★★ & Up</option>
                                <option value="1">★ & Up</option>
                            </select>
                        </div>


                        {/* BUTTONS */}
                        <div className="d-flex justify-content-between mt-3">
                            <button className="btn btn-light btn-sm reset-btn">Reset</button>
                            <button className="btn btn-dark btn-sm apply-btn">Apply</button>
                        </div>

                    </div>
                </div>


                {/* RIGHT LISTINGS */}
                <div className="col-md-9">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold">Businesses Listed</h5>
                        <select className="form-select w-auto">
                            <option>Sort By</option>
                            <option>Newest</option>
                            <option>Top Rated</option>
                        </select>
                    </div>

                    {/* BIG LOADER */}
                    {loading && (
                        <div className="text-center my-5">
                            <div
                                className="spinner-border text-primary"
                                style={{ width: "4rem", height: "4rem" }}
                                role="status"
                            ></div>
                            <p className="text-muted mt-3 fs-5">Loading results...</p>
                        </div>
                    )}

                    {/* NO RESULT */}
                    {!loading && listings.length === 0 && (
                        <p className="text-muted fs-5">No results found.</p>
                    )}

                    {/* RESULTS */}
                    {!loading &&
                        listings.length > 0 &&
                        listings.map((biz, index) => (
                            <div key={index} className="card mb-3 border border-secondary shadow-sm rounded-1">

                                <div className="row g-0">

                                    {/* IMAGE (Full width in mobile, left side in desktop) */}
                                    <div className="col-12 col-md-4">
                                        <img
                                            src={`${API_BASE}/uploads/${biz.profilepics}`}
                                            className="img-fluid rounded-start w-100"
                                            style={{ height: "100%", maxHeight: "190px", objectFit: "cover" }}
                                            alt={biz.title}
                                        />
                                    </div>

                                    {/* MIDDLE CONTENT */}
                                    <div className="col-12 col-md-6 p-3">

                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            <h5 className="fw-bold mb-0">{biz.title}</h5>
                                            <span className="badge bg-success">
                                                <i className="bi bi-patch-check-fill me-1"></i> Verified
                                            </span>
                                        </div>

                                        <p className="text-muted small mb-1">
                                            <i className="bi bi-geo-alt-fill text-primary"></i>{" "}
                                            {biz.muncipality}, {biz.district}, {biz.province}
                                        </p>

                                        <div className="d-flex flex-wrap gap-1 mb-2">
                                            {biz.keywords &&
                                                biz.keywords
                                                    .split(",")
                                                    .map(k => k.trim())
                                                    .filter(k => k.length > 0)
                                                    .slice(0, 4)
                                                    .map((tag, i) => (
                                                        <span key={i} className="badge bg-light text-dark">
                                                            {tag}
                                                        </span>
                                                    ))}
                                        </div>

                                        <p className="small text-muted mb-2">
                                            {biz.descriptions?.substring(0, 100)}...
                                        </p>

                                        {/* CONTACT INFO */}
                                        <div className="small">
                                            <div className="mb-1">
                                                <i className="bi bi-telephone-fill text-success me-2"></i>
                                                <strong>{biz.mobile}</strong>
                                            </div>
                                            <div className="mb-1">
                                                <i className="bi bi-envelope-fill text-danger me-2"></i>
                                                {biz.email}
                                            </div>
                                            <div>
                                                <i className="bi bi-globe text-primary me-2"></i>
                                                {biz.website}
                                            </div>
                                        </div>

                                        {/* BUTTONS */}
                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                            <button
                                                className="btn btn-success btn-sm d-flex align-items-center gap-1"
                                                onClick={() => {
                                                    setSelectedBiz(biz);
                                                    setShowCallPopup(true);
                                                }}
                                            >
                                                <i className="bi bi-telephone-fill"></i> Call
                                            </button>

                                            <button
                                                className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                                                onClick={() => goToProfile1(biz.id)}
                                            >
                                                <i className="bi bi-globe"></i> Website
                                            </button>

                                            <button
                                                className="btn btn-warning btn-sm text-dark d-flex align-items-center gap-1"
                                                onClick={() => {
                                                    setSelectedBiz(biz);
                                                    setUserMsg("");
                                                    setShowMsgPopup(true);
                                                }}
                                            >
                                                <i className="bi bi-chat-dots-fill"></i> Message
                                            </button>

                                            <button
                                                className="btn btn-outline-dark btn-sm d-flex align-items-center gap-1"
                                                onClick={() => goToProfile(biz.id)}
                                            >
                                                <i className="bi bi-eye-fill"></i> Profile
                                            </button>
                                        </div>

                                    </div>

                                    {/* RIGHT SIDE RATING */}
                                    <div className="col-12 col-md-2 p-3 text-md-end text-start d-flex flex-column justify-content-between">

                                        <div className="text-md-end text-start">
                                            <span className="badge bg-warning text-dark px-3 py-2 fs-6">
                                                ⭐ 4.7
                                            </span>
                                            <p className="small text-muted mt-1 mb-0">120 Reviews</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                </div>

                {/* CALL POPUP */}
                {showCallPopup && selectedBiz && (
                    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>

                        <div className="bg-white p-4 rounded shadow" style={{ width: "320px" }}>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">{selectedBiz.title}</h5>
                                <button className="btn btn-sm btn-danger" onClick={() => setShowCallPopup(false)}>X</button>
                            </div>

                            {/* PHONE NUMBER */}
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">{selectedBiz.mobile}</h4>
                            </div>

                            <button
                                className="btn btn-success w-100 mb-2"
                                onClick={() => window.location.href = `tel:${selectedBiz.mobile}`}
                            >
                                <i className="bi bi-telephone-fill"></i> Call Now
                            </button>

                            <button
                                className="btn btn-outline-success w-100 mb-2"
                                onClick={() => {
                                    setShowCallPopup(false);
                                    setUserMsg("");
                                    setShowMsgPopup(true);
                                }}
                            >
                                <i className="bi bi-whatsapp"></i> WhatsApp Message
                            </button>

                            <button
                                className="btn btn-secondary w-100"
                                onClick={() => {
                                    navigator.clipboard.writeText(selectedBiz.mobile);
                                    alert("Phone number copied!");
                                }}
                            >
                                <i className="bi bi-clipboard-check"></i> Copy Number
                            </button>
                        </div>
                    </div>
                )}
                {/* MESSAGE POPUP */}
                {showMsgPopup && selectedBiz && (
                    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>

                        <div className="bg-white p-4 rounded shadow" style={{ width: "350px" }}>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">Message {selectedBiz.title}</h5>
                                <button className="btn btn-sm btn-danger" onClick={() => setShowMsgPopup(false)}>X</button>
                            </div>

                            <p className="fw-bold small">Choose a message:</p>

                            {[
                                "Hello! I want to know more about your services.",
                                "Please share pricing details.",
                                "I am interested, please contact me.",
                                "Is this service available right now?"
                            ].map((msg, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setUserMsg(msg)}
                                    className="btn btn-outline-secondary text-start mb-2"
                                >
                                    {msg}
                                </button>
                            ))}

                            <textarea
                                className="form-control mt-3"
                                rows="3"
                                placeholder="Type your message..."
                                value={userMsg}
                                onChange={(e) => setUserMsg(e.target.value)}
                            ></textarea>

                            <button
                                className="btn btn-success w-100 mt-3"
                                onClick={() => {
                                    const phone = selectedBiz.mobile;
                                    const text = encodeURIComponent(userMsg);
                                    window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
                                }}
                            >
                                <i className="bi bi-whatsapp"></i> Send on WhatsApp
                            </button>
                        </div>
                    </div>
                )}



            </div>
        </div>
    );
}

export default Listings;
